import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const dropdownAnimation = trigger('dropdown', [
  state(
    'void',
    style({
      // opacity: 1,
      transform: 'scaleY(0) translateY(-10%)',
    })
  ),
  state(
    '*',
    style({
      // opacity: 1,
      transform: 'scaleY(1) translateY(0)',
    })
  ),
  transition('void => *', animate('225ms cubic-bezier(0.4,0.0,0.2,1)')),
  transition('* => void', animate('225ms cubic-bezier(0.4,0.0,0.2,1)')),
]);
export const stateOrCountryDropdownAnimation = trigger('stateOrCountryDropdownAnimation', [
  state(
    'void',
    style({
      // opacity: 1,
      transform: 'scaleY(0) translateY(10%)',
    })
  ),
  state(
    '*',
    style({
      // opacity: 1,
      transform: 'scaleY(1) translateY(0)',
    })
  ),
  transition('void => *', animate('225ms cubic-bezier(0.4,0.0,0.2,1)')),
  transition('* => void', animate('225ms cubic-bezier(0.4,0.0,0.2,1)')),
]);

export const fadeInOutAnimation = trigger('fadeInOut', [
  state(
    'void',
    style({
      opacity: 0,
    })
  ),
  transition('void <=> *', animate('400ms')),
]);

export const slideInOutAnimation = trigger('slideInOutAnimation', [
  state('in', style({ transform: 'translateY(0%)' })),
  transition(':enter', [
    style({ transform: 'translateY(100%)' }),
    animate('0.4s ease-in-out', style({ transform: 'translateY(0%)' })),
  ]),
  transition(':leave', [
    style({ transform: 'translateY(0%)' }),
    animate('0.4s ease-in-out', style({ transform: 'translateY(100%)' })),
  ]),
]);

export const overlayFadeInOutAnimation = trigger('overlayFadeInOutAnimation', [
  transition(':enter', [
    style({ opacity: 0 }),
    animate('0.4s ease-in', style({ opacity: 1 })),
  ]),
  transition(':leave', [animate('0.4s ease-out', style({ opacity: 0 }))]),
]);
